import { useCallback } from 'react';

import { getOddsClickTrackingData, getOddsSelection } from '../utils/ticket';

import { useSelectedOutcomeIds } from './use-selected-outcome-ids';
import { useToggleSelections } from './use-toggle-selections';
import { useTrackEvent } from './use-track-event';

export function useAddSelection() {
  const { eventCommonAttributes } = useTrackEvent();
  const selectedOutcomeIds = useSelectedOutcomeIds();
  const toggleSelections = useToggleSelections();

  const onAddSelections = useCallback(
    ({ selectionsData, isCustom, customOdds }) => {
      const selections = selectionsData.map(getOddsSelection);
      const trackingData = getOddsClickTrackingData(selectionsData, eventCommonAttributes);

      toggleSelections({ selections, isCustom, customOdds, trackingData });
    },
    [eventCommonAttributes, toggleSelections]
  );

  const addSelection = useCallback(
    selectionData => {
      onAddSelections({ selectionsData: [selectionData] });
    },
    [onAddSelections]
  );

  return { selectedOutcomeIds, onAddSelections, addSelection };
}
